@if (contactInfo()) {
  <mat-card class="example-card">
    <mat-card-header>
      <div class="header-content">
        <div class="header-text">
          <mat-card-title
            ><h3>{{ contactInfo().name }}</h3></mat-card-title
          >
        </div>
        @if (contactInfo().isAddBtn) {
          <div class="header-avatar">
            <button
              mat-button
              color="primary"
              class="custom-button"
              (click)="emitEvent([], 0, contactInfo().type, 'add')"
            >
              <mat-icon>add</mat-icon> Add
            </button>
          </div>
        }
      </div>
    </mat-card-header>
    @if (contactInfo().listItems.length > 0) {
      <mat-card-content>
        <mat-list>
          @for (list of contactInfo().listItems; track $index; let i = $index) {
            <mat-list-item class="list-content">
              <span mat-line class="list-text">
                @if (contactInfo().isPhoneNumber) {
                  {{ list.value | phoneFormat }}
                }
                @if (!contactInfo().isPhoneNumber) {
                  {{ list.value }}
                }
                @if (list.isDefault) {
                  <span>(Default)</span>
                }
              </span>
              @if (
                contactInfo().listOperation.delete && list.listOperationAllowed
              ) {
                <mat-icon
                  mat-list-icon
                  class="list-icon"
                  (click)="emitEvent(list, i, contactInfo().type, 'delete')"
                  >delete_outline</mat-icon
                >
              }
              @if (
                contactInfo().listOperation.edit && list.listOperationAllowed
              ) {
                <mat-icon
                  mat-list-icon
                  class="list-icon"
                  (click)="emitEvent(list, i, contactInfo().type, 'edit')"
                  >edit_outline</mat-icon
                >
              }
              @if (
                contactInfo().listOperation.arrow_down &&
                list.listOperationAllowed
              ) {
                <mat-icon
                  mat-list-icon
                  class="list-icon"
                  (click)="emitEvent(list, i, contactInfo().type, 'arrow_down')"
                  >arrow_downward</mat-icon
                >
              }
              @if (
                contactInfo().listOperation.arrow_up &&
                list.listOperationAllowed
              ) {
                <mat-icon
                  mat-list-icon
                  class="list-icon"
                  (click)="emitEvent(list, i, contactInfo().type, 'arrow_up')"
                  >arrow_upward</mat-icon
                >
              }
            </mat-list-item>
            @if (i !== contactInfo().listItems.length - 1) {
              <mat-divider />
            }
          }
        </mat-list>
      </mat-card-content>
    }
    @if (!contactInfo().listItems.length) {
      <mat-card-content>
        <mat-list class="empty-list">
          <mat-list-item class="list-content">
            <span mat-line class="list-text"> No records available </span>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    }
  </mat-card>
}
